module.exports = __webpack_public_path__ + "img/20191118160250360截图20191118102312024.52c736ef.jpg";